import { render } from "./allfiles.vue?vue&type=template&id=6a532fc1&scoped=true"
import script from "./allfiles.vue?vue&type=script&lang=js"
export * from "./allfiles.vue?vue&type=script&lang=js"

import "./allfiles.vue?vue&type=style&index=0&id=6a532fc1&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a532fc1"]])

export default __exports__